/**
 * ProductSizeService
 * Service for ProductSize entity operations
 * Route: api/product-sizes
 * Controller: ProductSizesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProductSizeService
 * Handles product size CRUD operations and filtered queries
 */
export class ProductSizeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProductSizeService.DEFAULT_SERVICE_PATH,
            basePath: ProductSizeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== FILTERED LIST ====================
    /**
     * Get all product sizes with optional product filter
     * GET /api/product-sizes?productId={productId}
     * @param productId - Optional product ID to filter sizes
     * @returns Array of product sizes
     */
    async getAll(productId) {
        const response = await this.getAllRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all product sizes with optional product filter (raw)
     * @param productId - Optional product ID to filter sizes
     * @returns ResponseData with product sizes
     */
    getAllRaw(productId) {
        const url = this.buildUrlWithParams(undefined, { productId });
        return this.http.get(url);
    }
}
ProductSizeService.DEFAULT_SERVICE_PATH = 'products';
ProductSizeService.BASE_PATH = 'api/product-sizes';
//# sourceMappingURL=ProductSizeService.js.map